/* eslint-disable no-lonely-if */
import React, { useRef, useState } from 'react';
import { icons } from '../../../../../configs/Icons';
import ReloadButton from '../../../../features/ReloadButton/ReloadButton';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonPest } from '../../../../utils/Button';
import { getApiUrl } from '../../../../utils/Env';
import { addOption, InputFieldSearch, SelectOption } from '../../../../utils/InputField';
import InstOption from '../../../../utils/InstOption';
import { OptionFillIcon } from '../../../../utils/SVGIcon';
import { useAgency } from '../../AgencyProvider';

function Option({
    handleDownloadClick,
    handleImportClick,
    handleInputChange,
    showMenu,
    setShowMenu,
    fileInputRef
}) {
    return (
        <div className="relative [&>.inst-option]:top-14 [&>.inst-option]:-right-2.5 hidden">
            <button type="button" className="size-[40px] block" onClick={() => setShowMenu(true)}>
                <OptionFillIcon />
            </button>

            <InstOption showMenu={showMenu} setShowMenu={setShowMenu} className="w-42">
                <button type="button" onClick={handleDownloadClick}>
                    Download Sample File
                </button>
                <button type="button" onClick={handleImportClick}>
                    <form encType="multipart/form-data">
                        <label className="cursor-pointer">
                            <input
                                type="file"
                                onChange={handleInputChange}
                                ref={fileInputRef}
                                hidden
                                accept=".xls, .xlsx"
                            />
                        </label>
                    </form>
                    Import Customers
                </button>
            </InstOption>
        </div>
    );
}

function PageHeaderLeftCol({ handleChangeFilterData, p }) {
    // const { initInfo } = useInit();

    return (
        <div className="customers_page_header_left_col w-full flex-1 flex items-center gap-x-2 md:gap-x-4">
            <InputFieldSearch
                label="Search by name, email or phone..."
                name="q"
                onChange={handleChangeFilterData}
                formData={p}
                className="rounded-10 lg:w-68 xl:w-76 max-w-76"
            />

            {/* <SelectWithCheck
                title="Customer Type"
                name="customerType"
                formData={p}
                onChange={handleChangeFilterData}
                options={initInfo.roles
                    ?.filter(({ key }) => key?.toLowerCase() !== 'admin')
                    ?.map(({ key, title }) => addOption(key, title, key?.toLowerCase()))}
                className="rounded-10 w-42"
            /> */}

            <SelectOption
                name="status"
                placeholder="Status"
                formData={p}
                onChange={handleChangeFilterData}
                options={['Active', 'Inactive']?.map((d) => addOption(d, d, d?.toLowerCase()))}
                className="rounded-10 w-38"
            />
        </div>
    );
}

function PageHeaderRightCol() {
    const { handleReload } = useAgency();
    const { openModal } = useTemplate();

    const [showMenu, setShowMenu] = useState(false);

    const fileInputRef = useRef(null);

    const handleDownloadClick = () => {
        // Close the menu
        setShowMenu(false);
        window.open(`${getApiUrl()}/api/customers-import/SampleData.xlsx`, '_blank');
    };

    const handleImportClick = () => {
        // Check if the file input is available
        if (fileInputRef.current) {
            // Trigger the input[type='file'] click event
            fileInputRef.current.click();
        }
    };

    const handleInputChange = (ev) => {
        if (!ev.target.files[0]) return;
        const formData = new FormData();
        formData.append('xlsxFile', ev.target.files[0]);
        // handleImportCustomer(formData)
        //     .then((res) => {
        //         // Close the menu
        //         setShowMenu(false);
        //         handleReload();
        //         setMessage({ type: 'success', text: res?.title });
        //         setTimeout(() => {}, 2000);
        //     })
        //     .catch((err) => {
        //         setMessage({ type: 'error', text: err?.toString(0) });
        //     });
    };

    return (
        <div className="customer_page_header_right_col flex-shrink-0 w-64 xl:flex-1 flex flex-row gap-2 justify-start xl:justify-end items-center ">
            <ReloadButton height="h-10" width="w-10" onClick={handleReload} />

            <ButtonPest
                type="button"
                onClick={() => openModal('create-agency-modal')}
                className="flex items-center justify-between gap-2 h-10"
            >
                <img src={icons.plusW} alt="" className="w-3 h-3" />
                <span>Create Agency</span>
            </ButtonPest>

            <Option
                handleDownloadClick={handleDownloadClick}
                handleImportClick={handleImportClick}
                handleInputChange={handleInputChange}
                fileInputRef={fileInputRef}
                showMenu={showMenu}
                setShowMenu={setShowMenu}
            />
        </div>
    );
}

function AgencyPageHeader({ handleChangeFilterData, p }) {
    return (
        <div className="customer_page_header w-full mb-3 md:mb-7 flex flex-row justify-between items-center gap-3 xl:gap-0">
            <PageHeaderLeftCol handleChangeFilterData={handleChangeFilterData} p={p} />
            <PageHeaderRightCol />
        </div>
    );
}

export default AgencyPageHeader;
